import styled from '@emotion/styled';

interface TableNumberBadgeProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableNumberBadge: React.FC<TableNumberBadgeProps> = ({
  data,
  dataKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];

  return <Container className={className}>{label}</Container>;
};

export default TableNumberBadge;
const Container = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  line-height: 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  padding: 5.5px 11px !important;
  user-select: none;
  height: fit-content;

  color: #5b91f5 !important;
  background-color: rgba(91, 145, 245, 0.05);
  border: 1px solid rgba(91, 145, 245, 0.1);
`;
